export enum ActionWord {
    deleted = "deleted",
    removed = "removed",
    created = "created",
    saved = "saved",
    retrieved = "retrieved",
    completed = "completed",
    enabled = "enabled",
    disabled = "disabled",
    moved = "moved",
    sent = "sent",
    loaded = "loaded",
    backedup = "backed up",
    restored = "restored",
    uploaded = "uploaded",
}
